module.exports = __webpack_public_path__ + "img/益视说明书_09.fdbd63e9.png";